// extracted by mini-css-extract-plugin
module.exports = {"checkboxContainer":"checkbox_checkboxContainer__W4zp9","inactive":"checkbox_inactive__i8H2W","checkbox":"checkbox_checkbox___JD9R","content":"checkbox_content__V3vVg"};